export default {
  en: {
    title: 'Buy now. Pay with Klarna at your own pace.',
    subTitle: 'Get what you love, choose how you pay.',
    timelineHeader: 'How it works',
    timelineItems: [
      {
        title: 'At checkout select Klarna',
        description: ''
      },
      {
        title: 'Choose your payment plan',
        description: 'Different payment plans may be shown depending on the purchase amount and credit score.'
      },
      {
        title: 'Complete your checkout',
        description: 'The amount will be charged based on the payment plan you chose.'
      }
    ]
  },
  it: {
    title: 'Compra subito con Klarna. Paga con calma.',
    subTitle: 'Lo shopping che vuoi. E paghi come vuoi.',
    timelineHeader: 'Come funziona',
    timelineItems: [
      {
        title: 'Al checkout, seleziona Klarna',
        description: ''
      },
      {
        title: 'Scegli il tuo piano di pagamento',
        description:
            'I piani di pagamento mostrati possono variare in base all\'importo dell\'acquisto e al punteggio di credito dell\'utente.'
      },
      {
        title: 'Completa l\'ordine',
        description: 'L\'importo verrà addebitato in base al piano di pagamento selezionato.'
      }
    ]
  }
}
